import { isHeaderOrFooterField } from './lockableFields';

const emptyFieldsToHide = ['greenhouse_content_pay_transparency', 'ashby_compensation_statement'];

export const shouldHideIfEmpty = ({
  type, sections, isTemplate, isFlagship,
}) => {
  if (!emptyFieldsToHide.includes(type) && !isHeaderOrFooterField(type)) {
    return false;
  }

  if (isHeaderOrFooterField(type) && (isTemplate || isFlagship)) {
    return false;
  }

  let html = '';
  (sections || []).forEach((section) => {
    (section.blocks || []).forEach((block) => {
      html += block.html || '';
    });
  });

  // empty field content usually is <p><br /></p> (13 chars)
  // let's consider anything less than 20 to be empty field
  return html.length < 20;
};
